import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateCustomer, CustomerReportPayload } from '../../shared/models/customer';

@Injectable()
export class CustomerService {
    constructor(private http: HttpClient) {}

    private url = `${environment.apiUrl}`;
    private southernOracleUrl = `${environment.apiUrl}`;

    createNewCustomer(customer: CreateCustomer): Observable<any> {
        return this.http.post<any>(`${this.url}/api/customer`, customer);
    }

    searchCustomerByNationalId(searchText: string): Observable<any> {
        return this.http.get<any>(`${this.url}/api/customer/find-by-national-id?nationalId=${searchText}`);
    }

    fetchQuotes(customerId: number): Observable<any> {
        return this.http.get<any>(`${this.url}/api/sme/quote`, {
            params: new HttpParams().set('customerId', customerId.toString()),
        });
    }

    generateCustomerReports(payload: CustomerReportPayload): Observable<any>{
        return this.http.post<any>(`${this.url}/api/report/customer-list`,payload);
    }
}
